export default __webpack_public_path__ + "static/media/Layer 22.b6935c8c.svg";